import type { DemoKey } from '../types';

export const ru: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'Математика · Статистика',
  'app.title': 'Статистика',
  'panel.experiment': 'Сцена',
  'panel.params': 'Параметры',

  'exp.survey-explorer.title': 'Обозреватель опросов',
  'exp.survey-explorer.desc': 'Выбери столбец; демо подберёт подходящую сводку.',
  'exp.distribution-sculptor.title': 'Скульптор распределений',
  'exp.distribution-sculptor.desc': 'Перетаскивай точки и смотри, как реагируют статистики.',
  'exp.two-variable-lab.title': 'Двумерная лаборатория',
  'exp.two-variable-lab.desc': 'Диаграмма рассеяния, подгонка и вопрос о причинности.',
  'exp.sampling-lab.title': 'Лаборатория выборки',
  'exp.sampling-lab.desc': 'Как метод и размер сдвигают среднее по выборке.',
  'exp.probability-diagrams.title': 'Диаграммы вероятностей',
  'exp.probability-diagrams.desc': 'Виды Венна и дерева для составных событий.',

  'type.qualitative-nominal.label': 'Качественный · номинальный',
  'type.qualitative-nominal.def': 'Категории без естественного порядка.',
  'type.qualitative-ordinal.label': 'Качественный · порядковый',
  'type.qualitative-ordinal.def': 'Категории с осмысленным порядком.',
  'type.qualitative-multi.label': 'Качественный · многозначный',
  'type.qualitative-multi.def': 'У каждого наблюдения может быть несколько меток.',
  'type.quantitative-discrete.label': 'Количественный · дискретный',
  'type.quantitative-discrete.def': 'Числа с фиксированным шагом.',
  'type.quantitative-continuous.label': 'Количественный · непрерывный',
  'type.quantitative-continuous.def': 'Числа на непрерывной шкале.',

  'column.name.label': 'Имя ученика',
  'column.height_cm.label': 'Рост',
  'column.shoe_size_eu.label': 'Размер обуви (EU)',
  'column.study_hours.label': 'Часов учёбы / неделю',
  'column.test_score.label': 'Балл за тест',
  'column.sports_played.label': 'Виды спорта',
  'column.eye_color.label': 'Цвет глаз',
  'column.commute_min.label': 'Дорога',
  'column.grade_year.label': 'Класс',
  'column.homework_effort.label': 'Усердие в дз',
  'column.ice-cream-sales.label': 'Продажи мороженого',
  'column.drownings.label': 'Утопления',
  'column.month.label': 'Месяц',
  'column.storks.label': 'Аисты',
  'column.births.label': 'Рождения',
  'column.country_area_km2.label': 'Площадь страны',
  'column.sleep_hours.label': 'Часы сна',
  'column.reaction_ms.label': 'Время реакции',

  'dataset.master-survey.label': 'Опрос класса',
  'dataset.master-survey.desc': '30 смоделированных учеников.',
  'dataset.spurious-ice-cream-vs-drownings.label': 'Мороженое vs утопления',
  'dataset.spurious-ice-cream-vs-drownings.desc':
    'Оба растут и падают вместе с сезоном. Утопления не вызывают продажи мороженого.',
  'dataset.spurious-storks-vs-births.label': 'Аисты vs рождения',
  'dataset.spurious-storks-vs-births.desc':
    'У больших стран больше аистов и больше рождений. Птицы не причина.',
  'dataset.real-sleep-vs-reaction-time.label': 'Сон vs время реакции',
  'dataset.real-sleep-vs-reaction-time.desc':
    'Больше сна — быстрее реакция. Настоящая отрицательная корреляция — с правдоподобным механизмом.',

  'tag.football.label': 'Футбол',
  'tag.basketball.label': 'Баскетбол',
  'tag.volleyball.label': 'Волейбол',
  'tag.swimming.label': 'Плавание',
  'tag.none.label': 'Никаких',

  'population.gaussian.label': 'Гауссова кривая',
  'population.right-skewed.label': 'С правым хвостом',
  'population.bimodal.label': 'Бимодальное (со страт.)',
  'population.uniform.label': 'Равномерное',

  'venn.dice-even-or-prime.label': 'Кубик: чётное или простое',
  'venn.class-sports-2set.label': 'Спорт (2 множества)',
  'venn.class-sports-3set.label': 'Спорт (3 множества)',
  'venn.custom.label': 'Своё',

  'tree.draw-without-replacement.label': 'Без возвращения',
  'tree.custom.label': 'Своё',
  'tree.coin.heads': 'О',
  'tree.coin.tails': 'Р',
  'tree.draw.start': 'Мешок: 2 красных, 3 синих',
  'tree.draw.red': 'Красный',
  'tree.draw.blue': 'Синий',
  'tree.custom.start': 'Старт',
  'tree.custom.A': 'A',
  'tree.custom.B': 'B',

  'card.histogram': 'Гистограмма',
  'card.cumulative': 'Накопленная частота',
  'card.box': 'Ящик с усами',
  'card.summary': 'Пять чисел',
  'card.bar': 'Столбчатая диаграмма',
  'card.mode': 'Мода',
  'card.tag-frequency': 'Частота меток',
  'card.mode-tag': 'Самая частая метка',
  'card.empty-no-order': 'Не применимо',
  'card.empty-multi': 'Не применимо',
  'card.numberline': 'Числовая прямая',
  'card.scatter': 'Рассеяние',
  'card.description': 'Что происходит',
  'card.population': 'Генеральная совокупность',
  'card.sampling-distribution': 'Выборочные средние',
  'card.venn': 'Венн',
  'card.tree': 'Дерево',
  'card.probabilities': 'Вероятности',

  'param.dataset.label': 'Набор данных',
  'param.column.label': 'Столбец',
  'param.bins.label': 'Интервалы',
  'param.shape.label': 'Начальная форма',
  'param.show-mean.label': 'Показать среднее',
  'param.show-median.label': 'Показать медиану',
  'param.x-col.label': 'Столбец X',
  'param.y-col.label': 'Столбец Y',
  'param.show-regression.label': 'Линия регрессии',
  'param.show-residuals.label': 'Остатки',
  'param.show-confounder.label': 'Показать конфаундер',
  'param.population.label': 'Совокупность',
  'param.technique.label': 'Метод',
  'param.sample-size.label': 'Размер выборки',
  'param.stratum.label': 'Страта',
  'param.bias.label': 'Смещение',
  'param.mode.label': 'Режим',
  'param.preset.label': 'Пресет',
  'param.universe.label': 'Размер пространства',
  'param.show-prob.label': 'Показать вероятности',
  'param.treat-as-numeric.label': 'Считать числовым',

  'stat.count': 'Количество',
  'stat.mean': 'Среднее',
  'stat.median': 'Медиана',
  'stat.range': 'Размах',
  'stat.q1': 'Q1',
  'stat.q3': 'Q3',
  'stat.iqr': 'МКР',
  'stat.outliers': 'Выбросы',
  'stat.r': 'r Пирсона',
  'stat.r2': 'r²',
  'stat.slope': 'Наклон',
  'stat.intercept': 'Свободный член',
  'stat.n': 'n',
  'stat.population-mean': 'Истинное среднее',
  'stat.latest-sample-mean': 'Среднее выборки',
  'stat.sample-mean-spread': 'СО среднего выборки',
  'stat.sample-count': 'Извлечено выборок',
  'outlier.upper': 'Верхние выбросы',
  'outlier.lower': 'Нижние выбросы',

  'region.A': 'A',
  'region.B': 'B',

  'btn.resample': 'Перевыбрать',
  'btn.run-100': '100 выборок',
  'btn.stop': 'Стоп',
  'btn.clear-history': 'Очистить историю',

  'explainer.no-order': 'Без порядка → нет накопленной, нет ящика.',
  'explainer.multi-no-iqr': 'Многозначное → квартили / МКР не определены.',
  'message.no-data': 'Нет данных.',
  'message.needs-quartiles': 'Нужно ≥4 точек для квартилей.',
  'message.x-zero-variance': 'У X нулевая дисперсия — нельзя подогнать прямую.',
  'message.n-too-small': 'n слишком мало.',
  'message.stratum-clamp': 'В страте меньше строк, чем запрошено — взяты все.',
  'message.siblings-sum-to-one': 'Сумма потомков должна быть 1.',
};
